export const router = [
  {
    path: "scheme",
    component: (resolve) => require(["./Index.vue"], resolve),
    children: [
      {
        path: "orderAllocation",
        component: (resolve) =>
          require(["./order-allocation/Index.vue"], resolve),
      },
      {
        path: "myScheme",
        component: (resolve) => require(["./my-scheme/Index.vue"], resolve),
      },
    ],
  },
];
